import { Upload } from '../../utils/upload';
import { useState, useEffect } from 'react';
import { Box, Button, FormControlLabel, Checkbox } from '@mui/material';
import { useGlobalStore } from 'store/globalStore';
import { useAppProviderStore } from 'store/appProviderCopyStore';
import { useForm, Controller } from 'react-hook-form';
import { useNotification } from 'hooks/useNotification';
import { useUploadData } from 'hooks/useUploadData';

export const transcoderMessages = {
  WAITING: 'WAITING', //'Aguardando a finalização do upload.',
  READY: 'READY', //'Pronto para começar a transcodificação.',
  UPLOADED: 'UPLOADED', //'Realizando o upload.',
  PROCESSING: 'PROCESSING', // 'Realizando a transcodificação',
  UNKNOWN: 'UNKNOWN', //'Status indefinido, verificar a etapa.',
  FINISHED: 'FINISHED', //'Processo de transcodificação realizado.',
  ERROR: 'ERROR', //'Erro na transcodificação'
};

function Uploader(props) {
  const { control, reset } = useForm();
  const { setNotify } = useNotification();
  const {
    register,
    icon,
    isDisabled,
    getValues,
    setValue,
    languages,
    fileInputRef,
    name,
    accept,
    setProps,
    type,
    title,
    setIsLoading,
    apiName,
    path,
    token,
    id,
    language,
    userId,
    userName,
    mediaContentType,
    setDuration,
    typeItem,
    isAcessibilityCheck,
    nameIsAcessibilityCheck,
  } = props;

  const { cancelUpload, setCancelUpload, setUploadIsLoading } =
    useGlobalStore();

  const [file, setFile] = useState(undefined);
  const [isChecked, setIsChecked] = useState(false);
  const {
    setVideoMainUploadProgress,
    setAudioMainUploadProgress,
    setVideoAcessibilityUploadProgress,
    setTrailerUploadProgress,
    setLegendaAccessibilityUploadProgress,
    setSubtitleMainUploadProgress,
    setLegendaTrailerUploadProgress,
    setMainUploaded,
    setTrailerUploaded,
    setAccessibilityUploaded,
    setAudioTrailerUploadProgress,
    setVideoMainUploadComplete
  } = useAppProviderStore();
  const uploadData = useUploadData(name);

  useEffect(() => {
    if (cancelUpload) {
      onCancel();
    }
  });

  useEffect(() => {
    if (file) {
      let mediId = getValues('mediaId');
      if (
        type.label === 'audio' &&
        !mediId &&
        mediaContentType !== 'COLLECTION'
      ) {
        setNotify({
          isOpen: true,
          message: 'Você deve incluir uma mídia de vídeo antes!',
          type: 'error',
        });
        return;
      }
      const videoUploaderOptions = {
        fileName: file.name,
        file: file,
        apiName,
        path,
        token,
        id,
        language,
        userId,
        userName,
        setIsLoading,
        setProps,
        setNotify,
        type,
        setValue,
        getValues,
        languages,
        setMainUploaded,
        setTrailerUploaded,
        setAccessibilityUploaded,
        setAuth: () => {},
        mediaContentType,
        setDuration,
        nameIsAcessibilityCheck,
        isChecked,
      };
      setIsLoading(true);
      setVideoMainUploadComplete(false);

      // let videoMainPercent = undefined;
      let percentage = undefined;

      const upload = new Upload(videoUploaderOptions);

      upload
        .onProgress(
          ({
            percentage: newPercentage,
            name,
            mainVideo,
            mainAudio,
            trailer,
            acessibility,
            mainLegenda,
            accessibilityLegenda,
            trailerLegenda,
          }) => {
            if (typeItem === 'EDIT') {
              setUploadIsLoading(true);
            }

            // to avoid the same percentage to be logged twice
            if (newPercentage !== percentage) {
              percentage = newPercentage;
              console.log(`${percentage}% ${name}`);

              if (type.label === 'legenda') {
                if (type.name === 'ACCESSIBILITY') {
                  setLegendaAccessibilityUploadProgress({
                    name: accessibilityLegenda.name,
                    type: accessibilityLegenda.type,
                    id: accessibilityLegenda.id,
                    description: accessibilityLegenda.description,
                    percent: Math.min(percentage, 100),
                  });
                }
                if (type.name === 'MAIN') {
                  setSubtitleMainUploadProgress({
                    name: mainLegenda.name,
                    type: mainLegenda.type,
                    id: mainLegenda.id,
                    description: mainLegenda.description,
                    percent: Math.min(percentage, 100),
                  });
                }
                if (type.name === 'TRAILER') {
                  setLegendaTrailerUploadProgress({
                    name: trailerLegenda.name,
                    type: trailerLegenda.type,
                    id: trailerLegenda.id,
                    description: trailerLegenda.description,
                    percent: Math.min(percentage, 100),
                  });
                }
              }
              if (type.label === 'video' && type.label !== 'legenda') {
                if (type.name === 'MAIN') {
                  // videoMainPercent = percentage;
                  setVideoMainUploadProgress({
                    name: mainVideo.name,
                    type: mainVideo.type,
                    id: mainVideo.id,
                    description: mainVideo.description,
                    isFinished: mainVideo.isFinished,
                    percent: Math.min(percentage, 100),
                  });
                }
              }
              if (
                type.label === 'audio' &&
                type.label !== 'legenda' &&
                type.model === 'MAIN'
              ) {
                setAudioMainUploadProgress({
                  name: mainAudio.name,
                  type: mainAudio.type,
                  id: mainAudio.id,
                  description: mainAudio.description,
                  percent: Math.min(percentage, 100),
                });
              }

              if (
                type.label === 'audio' &&
                type.label !== 'legenda' &&
                type.model === 'TRAILER'
              ) {
                setAudioTrailerUploadProgress({
                  name: mainAudio.name,
                  type: mainAudio.type,
                  id: mainAudio.id,
                  description: mainAudio.description,
                  percent: Math.min(percentage, 100),
                });
              }

              if (type.name === 'TRAILER' && type.label !== 'legenda') {
                setTrailerUploadProgress({
                  name: trailer.name,
                  type: trailer.type,
                  id: trailer.id,
                  description: trailer.description,
                  percent: Math.min(percentage, 100),
                });
              }
              if (type.name === 'ACCESSIBILITY' && type.label !== 'legenda') {
                setVideoAcessibilityUploadProgress({
                  name: acessibility.name,
                  type: acessibility.type,
                  id: acessibility.id,
                  description: acessibility.description,
                  percent: Math.min(percentage, 100),
                });
              }

              if (Math.min(percentage, 100) === 100) {
                resetCheckbox();
                uploadData.resetUpload();
              }
            }
          }
        )
        .onError(error => {
          setFile(undefined);
          setIsLoading(false);
          uploadData.resetUpload();
          console.error(error);
        })
        .onFinish(() => {
          setVideoMainUploadComplete(true);
        });

      upload.start();
      uploadData.setUploadById(name, upload);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [file]);

  const onCancel = () => {
    if (uploadData.getUpload()) {
      uploadData.getUpload().abort();
      uploadData.resetUpload();
      setIsLoading(false);
      setFile(undefined);
      setCancelUpload(false);
    }
  };

  const resetCheckbox = () => {
    setIsChecked(false);
    reset({ nameIsAcessibilityCheck: false });
  };

  const handleCheckboxClick = () => {
    setIsChecked(prevState => !prevState);
  };

  return (
    <Box sx={{ flexDirection: 'row', display: 'flex' }}>
      <Box>
        <Button
          variant="outlined"
          style={{
            width: '274px',
            textTransform: 'capitalize',
            fontSize: 16,
            fontWeight: '600',
            color: 'rgba(20, 97, 164, 1)',
            padding: '2px 15px',
            borderRadius: 8,
          }}
          startIcon={icon}
          component="label"
          disabled={Boolean(isDisabled)}>
          {title}
          <input
            hidden
            name="file"
            type="file"
            accept={accept}
            {...register(name, {
              required: true,
            })}
            ref={fileInputRef}
            onChange={e => {
              setFile(e.target?.files?.[0]);
            }}
            value={''}
            onClick={e => (e.target.value = null)}
          />
        </Button>
      </Box>
      {isAcessibilityCheck && (
        <Box
          sx={{
            marginLeft: '16px',
            justifyContent: 'center',
            alignItems: 'center',
          }}>
          <FormControlLabel
            label={'Acessibilidade'}
            disabled={Boolean(isDisabled)}
            control={
              <Controller
                name={nameIsAcessibilityCheck}
                control={control}
                rules={{ required: true }}
                render={({ field: { value, ...field } }) => (
                  <Checkbox
                    {...field}
                    checked={!!value}
                    value={isChecked}
                    onClick={() => {
                      handleCheckboxClick();
                    }}
                  />
                )}
              />
            }
          />
        </Box>
      )}
    </Box>
  );
}

export default Uploader;
